import { createStyles } from 'antd-style'

export const useStyles = createStyles(({ token }) => ({
  header: {
    border: `1px solid ${token.lightGrey.lightGrey2}`,
    display: 'flex',
    alignItems: 'center',
    justifyContent: 'space-between'
  },
  divider: {
    borderColor: `${token.grey.grey3} !important`,
    height: '39px',
    marginInline: 0
  }
}))
